import {
  BlockControls,
  MediaReplaceFlow,
  MediaUpload,
  MediaUploadCheck,
  __experimentalLinkControl,
} from '@wordpress/block-editor';
import { Button, Popover, ToolbarButton, ToolbarGroup } from '@wordpress/components';
import { useState } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import React from 'react';

interface ControlsProps {
  attributes: {
    imageId?: number;
    imageSrc?: string;
    url?: string;
    opensInNewTab?: boolean;
    icon?: string;
  };
  onSelectImage: (image: any) => void;
  onRemoveImage: () => void;
  setAttributes: (attributes: Record<string, any>) => void;
}

const Controls: React.FC<ControlsProps> = ({
  attributes: { imageId, imageSrc, url, opensInNewTab },
  onSelectImage,
  onRemoveImage,
  setAttributes,
}) => {
  const [isLinkControlOpen, setIsLinkControlOpen] = useState(false);

  const toggleLinkControl = (isOpen: boolean) => setIsLinkControlOpen(isOpen);

  const handleLinkChange = (link: { url: string; opensInNewTab: boolean }) =>
    setAttributes({ url: link.url, opensInNewTab: link.opensInNewTab });

  const ImageControls = () => (
    <MediaReplaceFlow
      name={__('Replace Image', 'neodigital')}
      mediaId={imageId}
      mediaURL={imageSrc}
      allowedTypes={['image']}
      onSelect={onSelectImage}
      render={({ open }) => (
        <>
          <ToolbarButton icon="format-image" label={__('Replace Image', 'neodigital')} onClick={open} />
          <Popover position="bottom center" onClose={() => {}}>
            <Button isSecondary onClick={onRemoveImage} className="components-button is-destructive">
              {__('Remove Image', 'neodigital')}
            </Button>
          </Popover>
        </>
      )}
    />
  );

  const LinkControls = () => (
    <>
      <ToolbarButton
        icon="admin-links"
        label={__('Edit Link', 'neodigital')}
        onClick={() => toggleLinkControl(true)}
      />
      {isLinkControlOpen && (
        <Popover position="bottom center" onClose={() => toggleLinkControl(false)}>
          <__experimentalLinkControl
            forceIsEditingLink={true}
            value={{ url, opensInNewTab, title: url }}
            onChange={handleLinkChange}
          />
        </Popover>
      )}
    </>
  );

  return (
    <BlockControls>
      <ToolbarGroup>
        <ImageControls />
      </ToolbarGroup>
      <ToolbarGroup>
        <LinkControls />
      </ToolbarGroup>
    </BlockControls>
  );
};

export default Controls;
